module.exports = __webpack_public_path__ + "img/facebook-icon-white.11e2faca.svg";